<template lang="pug">
  div.wrap-item-doodle-image
    div(:style="rectStyle" :class="animationClassName").wrap-img.f.fh
      img(:src="doodle.imgURL").object-fit-cover
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/doodleAnimation.scss";

.wrap-item-doodle-image {
  position: absolute;
  .wrap-img {
    overflow: hidden;
  }
}
</style>

<script>

export default {
  props: {
    doodle: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      rectStyle: null,
    }
  },
  computed: {
    animationClassName () {
      return this.doodle.animation ? `doodle-animation-${this.doodle.animation}` : ''
    }
  },
  created () {
    // this.positionStyle = `top: ${this.doodle.top}%; left: ${this.doodle.left}%;`
    //   // + ` width: ${this.doodle.width / this.doodle.slideImgWidth * 100}%;`
    //   // + ` height: ${this.doodle.height / this.doodle.slideImgHeight * 100}%;`
    //   + ` width: ${this.doodle.width}px;`
    //   + ` height: ${this.doodle.height}px;`

    this.rectStyle = `width: ${this.doodle.width}px; height: ${this.doodle.height}px;`

    // this.rectStyle = `width: ${this.doodle.width / this.doodle.slideImgWidth * 100}%;`
    //   + ` height: ${this.doodle.height / this.doodle.slideImgHeight * 100}%;`
  }
}
</script>
